module.exports = __webpack_public_path__ + "files/ccfb730ceaaa4392dd083f1b7e570e9c.png";